// Code generated by @hex-insights/frontend-generator; DO NOT EDIT.
import { Route, useActivePageRegistration } from "@hex-insights/router";
import { PageRouteSwitch } from "../../Components";
import { AnnouncementHub } from "./Announcement";
import { announcementHubPageInfo } from "./Announcement/pageinfo";
import { CalendarEventHub } from "./CalendarEvent";
import { calendarEventHubPageInfo } from "./CalendarEvent/pageinfo";
import { HubsIndexPage } from "./IndexPage";
import { hubsIndexPageInfo } from "./IndexPage/pageinfo";
import { NewsletterHub } from "./Newsletter";
import { newsletterHubPageInfo } from "./Newsletter/pageinfo";
import { hubsPageInfo } from "./pageinfo";
import { PermissionGroupHub } from "./PermissionGroup";
import { permissionGroupHubPageInfo } from "./PermissionGroup/pageinfo";
import { PostHub } from "./Post";
import { postHubPageInfo } from "./Post/pageinfo";
import { UserHub } from "./User";
import { userHubPageInfo } from "./User/pageinfo";
import { UserGroupHub } from "./UserGroup";
import { userGroupHubPageInfo } from "./UserGroup/pageinfo";
import "./styles.css";

export function HubsPage() {
	useActivePageRegistration(hubsPageInfo);

	return (
		<PageRouteSwitch>
			<Route {...hubsIndexPageInfo.routeProps}>
				<HubsIndexPage />
			</Route>
			<Route {...announcementHubPageInfo.routeProps}>
				<AnnouncementHub />
			</Route>
			<Route {...calendarEventHubPageInfo.routeProps}>
				<CalendarEventHub />
			</Route>
			<Route {...newsletterHubPageInfo.routeProps}>
				<NewsletterHub />
			</Route>
			<Route {...permissionGroupHubPageInfo.routeProps}>
				<PermissionGroupHub />
			</Route>
			<Route {...postHubPageInfo.routeProps}>
				<PostHub />
			</Route>
			<Route {...userHubPageInfo.routeProps}>
				<UserHub />
			</Route>
			<Route {...userGroupHubPageInfo.routeProps}>
				<UserGroupHub />
			</Route>
		</PageRouteSwitch>
	);
}
